module.exports = __webpack_public_path__ + "static/media/dm-logo.653353ca.png";